import { notEmpty, useFallbackStorageValue } from "@product/scmp-sdk";
import { useUpdateEffect } from "@react-hookz/web";
import type { FunctionComponent } from "react";
import { useState } from "react";

import IconArrowNext from "./icon-arrow-next.svg";
import IconArrowPrevious from "./icon-arrow-previous.svg";
import { ButtonArea, Container, Label } from "./styles";

export const StoryStyleOverlayTutorial: FunctionComponent = () => {
  const [isOverlayHidden, setIsOverlayHidden] = useState(true);

  const { set: setLastSync, value: lastSync } = useFallbackStorageValue("overlayTutorialLastSync", {
    initializeWithValue: false,
  });

  useUpdateEffect(() => {
    setIsOverlayHidden(notEmpty(lastSync));
  }, [lastSync]);

  const handleClick = () => {
    setLastSync(String(Date.now()));
  };

  return (
    <Container $isOverlayHidden={isOverlayHidden} onClick={handleClick}>
      <ButtonArea $type="previous">
        <IconArrowPrevious />
        <Label>tap back</Label>
      </ButtonArea>
      <ButtonArea $type="next">
        <IconArrowNext />
        <Label>tap next</Label>
      </ButtonArea>
    </Container>
  );
};

StoryStyleOverlayTutorial.displayName = "StoryStyleOverlayTutorial";
